import { GraphQlClient, Moment } from '@intelipost-js/secure-providers';

export default {
  getHistoryLogs({ commit }, params) {
    commit('toggleLoading', true);

    const {
      search_value,
      created_data,
      data_excluded,
      current_page,
      page_size,
    } = params;

    const config = {
      order_number: search_value,
      start_created_date: created_data ? Moment(created_data.start || null).format('YYYY-MM-DD') : null,
      end_created_date: created_data ? Moment(created_data.end || null).format('YYYY-MM-DD') : null,
      start_deleted_date: data_excluded ? Moment(data_excluded.start || null).format('YYYY-MM-DD') : null,
      end_deleted_date: data_excluded ? Moment(data_excluded.end || null).format('YYYY-MM-DD') : null,
      current_page,
      page_size,
    };

    return GraphQlClient.query(`
    query (
      $order_number: [String]
      $start_deleted_date: Date
      $end_deleted_date: Date
      $start_created_date: Date
      $end_created_date: Date
      $current_page: Int
      $page_size: Int
      ) {
        getHistoryLogs (
          order_number: $order_number
          start_deleted_date: $start_deleted_date
          end_deleted_date: $end_deleted_date
        start_created_date: $start_created_date
        end_created_date: $end_created_date
        current_page: $current_page
        page_size: $page_size
        ) {
          total
          current_page
          items {
            user_id
            shipment_order_number
            shipment_order_volume_id
            shipment_order_volume_state_id
            created
            event_date
            provider_message
            intelipost_message
            provider_state
            micro_state_id
            deleted_date
          }
        }
      }`, config)
      .then((response = {}) => {
        const { data = {} } = response;
        const { getHistoryLogs = {} } = data;
        commit('setListOrders', getHistoryLogs);
        commit('toggleLoading', false);
        return Promise.resolve(getHistoryLogs);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },

};




// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/order-logs/store/actions.js